// creates history object to be used with BrowserRouter
// can be imported anywhere (including sagas) to force page change

import { createBrowserHistory } from 'history';

export default createBrowserHistory();
